import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sedan"
const SedanIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.36 9.188C13.232 9.188 14.074 9.508 14.726 10.088L17.106 12.203 20.062 12.43C21.332 12.528 22.312 13.588 22.312 14.86V16.5C22.313 17.225 21.726 17.813 21 17.813H19.45C19.042 18.38 18.377 18.75 17.625 18.75S16.208 18.38 15.8 17.813H8.575C8.167 18.38 7.502 18.75 6.75 18.75S5.333 18.38 4.925 17.813H3C2.275 17.813 1.688 17.225 1.688 16.5V14.25C1.688 12.904 2.778 11.813 4.124 11.813H4.642L6.223 10.23C6.891 9.563 7.798 9.188 8.743 9.188zM6.75 15.75C6.336 15.75 6 16.086 6 16.5S6.336 17.25 6.75 17.25 7.5 16.914 7.5 16.5 7.164 15.75 6.75 15.75M17.625 15.75C17.211 15.75 16.875 16.086 16.875 16.5S17.211 17.25 17.625 17.25 18.375 16.914 18.375 16.5 18.039 15.75 17.625 15.75M4.125 12.938C3.4 12.938 2.813 13.525 2.813 14.25H3.375C3.685 14.25 3.938 14.502 3.938 14.813S3.686 15.375 3.375 15.375H2.813V16.5C2.813 16.604 2.896 16.688 3 16.688H4.509Q4.5 16.595 4.5 16.5C4.5 15.257 5.507 14.25 6.75 14.25S9 15.257 9 16.5Q9 16.595 8.991 16.688H15.384Q15.376 16.595 15.375 16.5C15.375 15.257 16.382 14.25 17.625 14.25S19.875 15.257 19.875 16.5Q19.875 16.595 19.866 16.688H21C21.104 16.688 21.188 16.604 21.188 16.5V15.563H21C20.69 15.563 20.438 15.31 20.438 15S20.689 14.438 21 14.438H21.116C20.95 13.954 20.51 13.594 19.976 13.553L16.85 13.313H6.694L4.82 12.937zM8.743 10.312C8.096 10.313 7.476 10.57 7.019 11.028L6.015 12.029 6.805 12.188H9.939V10.312zM11.063 12.189H15.396L13.979 10.928C13.533 10.532 12.957 10.314 12.359 10.313H11.064z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SedanIcon
